import { Routes } from '@angular/router';
import { SubmissionDashboardComponent } from './components/submission-dashboard.component';
import { JobWorkspaceComponent } from './components/job-workspace.component';
import { SubmittingEntityWorkspaceComponent } from './components/submitting-entity-workspace.component';

export const submissionRoutes: Routes = [
  {
    path: 'submission',
    component: SubmissionDashboardComponent,
    data: {
      title: 'Submission',
      isNav:  true,
      icon: 'cloud_upload',
      permissions: ['SubmissionModule.Jobs:View']
    },
    children: [
    ]
  },
  {
    path: 'job-workspace/:key',
    component: JobWorkspaceComponent,
    data: {
      permissions: ['SubmissionModule.Jobs:View']
    }
  },
  {
    path: 'submitting-entity-workspace/:key',
    component: SubmittingEntityWorkspaceComponent,
    data: {
      permissions: ['SubmissionModule.SubmittingEntity:View']
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/submission/routes.config.ts